<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ this.data ? "Chỉnh sửa" : "Thêm mới" }} người dùng</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
        </div>

        <vs-divider class="mb-0"></vs-divider>
            <div class="p-6">
                <!-- username -->
                <vs-input
                    class="w-full mt-4"
                    label="Tên đăng nhập"
                    v-model="user_data.name"
                    v-validate="'required|alpha_num'"
                    name="username"
                />
                <span class="text-danger text-sm" v-show="errors.has('username')">{{ errors.first("username") }}</span>

                <!-- display_name -->
                <vs-input
                    class="w-full mt-4"
                    label="Tên hiển thị"
                    v-model="user_data.display_name"
                    v-validate="'required'"
                    name="display_name"
                />
                <span class="text-danger text-sm" v-show="errors.has('display_name')">{{ errors.first("display_name") }}</span>

                <!-- password -->
                <vs-input
                    class="w-full mt-4"
                    label="Mật khẩu"
                    v-model="password"
                    type="password"
                    name="password"
                />

                <!-- role -->
                <div v-if="$acl.check('createUserPermission')" class="mt-12">
                    <label class="vs-input--label">Role</label>
                    <v-select
                        v-model="user_data.role"
                        :clearable="false"
                        :options="roleOps"
                        v-validate="'required'"
                        name="role"
                        :reduce="e => e.toLowerCase()"
                        :disabled="this.data && user_data.role == 'sub'"
                    />
                    <span class="text-danger text-sm" v-show="errors.has('role')">{{ errors.first("role") }}</span>
                </div>

                <!-- Show all member's name -->
                <div v-if="user_data.role == 'user' || user_data.role == 'agent'" class="mt-12">
                    <vs-switch v-model="user_data.show_all">
                        <span slot="on">Hiện toàn bộ tên members</span>
                        <span slot="off">Hiện *** với members ko quản lý</span>
                    </vs-switch>
                </div>
            </div>

        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="save_changes" :disabled="!validateForm">Đồng ý</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Hủy</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
import vSelect from 'vue-select';
import Swal from 'sweetalert2';
import { AclRule } from 'vue-acl';

export default {
    props: {
        isSidebarActive: {
            type: Boolean,
            required: true
        },
        data: {
            type: Number,
            default: () => {}
        }
    },
    data() {
        return {
            user_data: { "id": 0, "name": "", "display_name": "", "role": "sub", "user_data": false },
            user_not_found: false,
          
            password: "",
            role: "",
            roleOps: this.data ? ["Admin", "Agent", "User", "Sub"] : []
        };
    },
    components: {
        vSelect
    },
    computed: {
        validateForm () {
            return !this.errors.any();
        },
        isSidebarActiveLocal: {
            get () {
                return this.isSidebarActive;
            },
            set (val) {
                if (!val) {
                    this.reset_data();
                    this.$emit('closeSidebar', false);
                    // this.$validator.reset()
                    // this.initValues()
                }
            }
        },
        isFormValid () {
            return !this.errors.any();
        },
        createUserPermission(){
            return new AclRule('create_users').generate();
        },
        fetchUserPermission(){
            return new AclRule('show_users').or('sub_show_users').generate();
        }
    },
    watch:{
        isSidebarActive(newVal){
            if(newVal === true && this.data){
                this.fetchUser(this.data);
            }else{
                this.reset_data();
                this.roleOps = ["Admin", "Agent", "User", "Sub"];
            }
        }
    },
    methods: {
        fetchUser(userId) {
            if(this.$acl.not.check('fetchUserPermission')) return;

            let vm = this;

            this.$http
                .get(`users/${userId}`)
                .then((res) => {
                    vm.user_data = res.data.data;
                    vm.roleOps = (res.data.data.role == "user" || res.data.data.role == "agent") ? ["Admin", "Agent", "User"] : [];
                })
                .catch((err) => {
                    if (err.response.status === 404) {
                        this.user_not_found = true;
                        return;
                    }
                    console.error(err);
                });
        },
        save_changes () {
            let vm = this;
            if (!vm.validateForm) return;

            let payload = {
                "name": vm.user_data.name,
                "display_name": vm.user_data.display_name
            };

            if(this.$acl.check('createUserPermission')){
                payload.role = vm.user_data.role;
                if(payload.role == 'user' || payload.role == 'agent'){
                    payload.show_all = vm.user_data.show_all;
                }
            }

            if(vm.password != ""){
                payload.password = vm.password;
            }

            if(vm.data){ //edit
                vm.$http.put(`users/${vm.data}`, payload)
                        .then(res => {
                            if(res.data.code == 0){
                                Swal.fire("", "Chỉnh sửa người dùng thành công", 'success');
                                vm.isSidebarActiveLocal = false;
                                vm.$emit("reload-users");
                            }else{
                                Swal.fire("", res.data.msg, 'error');
                            }
                        });
            }else{
                vm.$http.post("users", payload)
                        .then(res => {
                            if(res.data.code == 0){
                                Swal.fire("", "Tạo người dùng thành công", 'success');
                                vm.isSidebarActiveLocal = false;
                                vm.$emit("reload-users");
                            }else{
                                Swal.fire("", res.data.msg, 'error');
                            }
                        });
            }
            
        },
        reset_data () {
            this.user_data = { "id": 0, "name": "", "display_name": "", "role": "sub", "user_data": false };
        },
    },
};
</script>

<style>
.swal2-container{
    z-index: 99999;
}
.vs-sidebar--background{
    z-index: 99998;
}
</style>
